<template>
  <div class="order_block products-block">
    <template v-if="!(orderId > 0)">
      <h3 class="title">Информация о заказе</h3>
    </template>
    <template v-if="orderId > 0">
      <h3 class="title wh">
        Ваш заказ №{{orderId}}
        <hint-button>
          <template v-slot:hint-text>
            Ваш заказ <br> №{{orderId}}
          </template>
        </hint-button>
      </h3>
    </template>
    <div class="content">
      <div class="products_list">
        <div class="item" v-for="product in basketData" :key="product">
          <div class="left">
            <template v-if="product.image != null">
              <img @error="error_load_img(product)" :src="product.image" @click="navigate(product)">
            </template>
            <template v-if="product.image == null">
              <img :src="empty_image" @click="navigate(product)">
            </template>
            <div class="main">
              <span class="title" @click="navigate(product)" v-html="product.name">
              </span>
              <div class="qwt_art">
                <span class="quantity">Кол-во: {{product.quantity}} шт</span>
                <span class="article">Артикул: {{product.article}}</span>
              </div>
            </div>
          </div>
          <div class="right">
            <div class="price">
              <span class="val">{{product.total_price}}</span>
              <span class="desc">без скидки</span>
            </div>
            <div class="sep"></div>
            <div class="price discount">
              <span class="val">{{product.total_custom_price}}</span>
              <span class="desc">со скидкой</span>
            </div>
          </div>
          <div class="mobile">
            <div class="qwt_art">
              <span class="quantity">Кол-во: {{product.quantity}} шт</span>
              <span class="article">Артикул: {{product.article}}</span>
            </div>
            <div class="price base">
              <span class="desc">без скидки</span>
              <span class="val">{{product.total_price}}</span>
            </div>
            <div class="price discount">
              <span class="desc">со скидкой</span>
              <span class="val">{{product.total_custom_price}}</span>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>

import HintButton from "@/components/share/HintButton";
export default {
  name: 'ProductsBlock',
  props : {
    orderId : Number,
    basketData : Array
  },
  components: {
    HintButton

  },
  data() {
    return{
      empty_image : require('@/assets/catalog/product/empty.svg')
    }
  },
  mounted() {

  },
  methods : {
    error_load_img: async function(product) {
      product.image = this.empty_image;
    },
    navigate : function(product) {
      this.$router.push(
          {
            name:'catalog_product',
            params: {
              product: product.product_id,
              section: product.section_code
            }
          }
      )
    },
  }
}
</script>

<style scoped>

.products-block {
  display: flex;
  flex-direction: column;
  gap: 20px;
  padding-bottom: 6px;
}

.products-block .title.wh {
  display: flex;
  gap: 6px;
}

.products_list {

}

.products_list .item {
  border-top: 1px solid var(--Border, #EDEDED);
  background: var(--White, #FFF);
  padding: 14px 20px;
  display: flex;
  justify-content: space-between;
  margin: 0px -20px;
  align-items: center;
}

.products_list .item .left {
  display: flex;
  gap: 16px;
}

.products_list .item .left img{
  width: 62px;
  height: 62px;
  border-radius: 8px;
  border: 1px solid var(--Border, #EDEDED);
  background: var(--BG, #F8F8F8);
  cursor: pointer;
  box-sizing: border-box;
  background: #fff;
}

.products_list .item .left .main {
  width: 275px;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
}

.products_list .item .left .main .title{
  color: var(--Black, #222);
  font-family: Inter;
  font-size: 14px;
  font-style: normal;
  font-weight: 500;
  cursor: pointer;

  -webkit-line-clamp: 2;
  line-clamp: 2;
  display: -webkit-box;
  -webkit-box-orient: vertical;
  overflow: hidden;
}

.products_list .item .left .main .qwt_art {
  color: var(--Gray, #656565);
  font-family: Inter;
  font-size: 13px;
  font-style: normal;
  font-weight: 400;
  display: flex;
  gap: 24px;
}

.products_list .item .right {
  display: flex;
  gap: 20px;
}

.products_list .item .right .sep{
  width: 1px;
  background: var(--Border);
}

.products_list .item .right .price{
  display: flex;
  flex-direction: column;
  gap: 4px;
  align-items: end;
}

.products_list .item .right .price .val {
  color: var(--Black, #222);
  text-align: right;
  font-family: Inter;
  font-size: 16px;
  font-style: normal;
  font-weight: 500;
}

.products_list .item .right .price .desc {
  color: var(--Gray, #656565);
  font-family: Inter;
  font-size: 13px;
  font-style: normal;
  font-weight: 400;
}

.mobile {
  display: none;
}

/*MOBILE*/
@media (max-width: 1250px)
{
  .mobile {
    display: block;
  }

  .products-block {
    gap: 18px;
    padding-bottom: 6px;
  }

  .products_list .item {
    flex-direction: column;
    align-items: start;
    margin: 0px -18px;
    padding: 18px;
  }

  .products_list .item .left {
    gap: 12px;
    align-items: center;
  }

  .products_list .item .right {
    display: none;
  }

  .products_list .item .left .main .qwt_art {
    display: none;
  }

  .products_list .item .left img {
    width: 60px;
    height: 60px;
  }

  .products_list .item .left .main {
    width: 100%;
  }

  .products_list .item .left .main .title {
    -webkit-line-clamp: 3;
  }

  .mobile {
    width: 100%;
  }

  .mobile .qwt_art {
    color: var(--Gray, #656565);
    font-family: Inter;
    font-size: 13px;
    font-style: normal;
    font-weight: 400;
    display: flex;
    gap: 24px;
    justify-content: space-between;
    margin-top: 10px;
    margin-bottom: 16px;
  }

  .mobile .price {
    display: flex;
    justify-content: space-between;
  }

  .mobile .price .desc{
    color: var(--Gray, #656565);
    font-family: Inter;
    font-size: 14px;
    font-style: normal;
    font-weight: 400;
  }

  .mobile .price .val{
    color: var(--Black, #222);
    text-align: right;
    font-family: Inter;
    font-size: 14px;
    font-style: normal;
    font-weight: 400;
  }

  .mobile .price.base {
    margin-bottom: 10px;
  }
}
</style>



<style>

</style>
